export default __webpack_public_path__ + "static/media/3.ed5f9ad4.mp4";